/*
 * Copyright (c) 2021 Daimler AG. All rights reserved.
 * Implemented 2021 by DCCS GmbH.
 */
import React from 'react';
import SearchIcon from './search.svg';
import CollapsiblePanelIcon from './collapsible-panel.svg';
import ChevronDownIcon from './chevron-down.svg';
import ChevronRightIcon from './chevron-right.svg';
import ChevronLeftIcon from './chevron-left.svg';
import Pencil from './pencil.svg';
import Calendar from './calendar.svg';
import CalendarWhite from './calendar_white.svg';
import Clear from './clear.svg';
import ClearAlt from './clear-alt.svg';
import Upload from './upload.svg';
import UploadAlt from './uploadAlt.svg';
import User from './user.svg';
import Commercial from './house.svg';
import Calculations from './calculations.svg';
import Insurance from './insurance.svg';
import CoApplicants from './coApplicants.svg';
import CoApplicantsRed from './coApplicants_red.svg';
import Customer from './customer.svg';
import CustomerRed from './customer_red.svg';
import ChevronRightWhite from './chevron-right-white.svg';
import ChevronLeftWhite from './chevron-left-white.svg';
import Ellipse from './ellipse.svg';
import Polygon from './polygon.svg';
import Rectangle from './rectangle.svg';
import Trash from './trash.svg';
import Alert from './alert.svg';
import Open from './open.svg';
import Print from './print.svg';
import Documents from './documents.svg';
import Download from './download.svg';
import Checked from './checked.svg';
import RedInfo from './red-info.svg';
import Chart from './chart.svg';

function renderIcon(iconItself: any, classes: string[] = []): JSX.Element {
  return <img className={[...classes].join(' ')} src={iconItself} alt="Icon" />;
}

/**
 * Export icons of various kind in form of SVGs.
 */
export const Icons = {
  alert: (...classNames: string[]): JSX.Element => renderIcon(Alert, classNames),
  search: (...classNames: string[]): JSX.Element => renderIcon(SearchIcon, classNames),
  collapsiblePanel: (...classNames: string[]): JSX.Element =>
    renderIcon(CollapsiblePanelIcon, classNames),
  chevronDown: (...classNames: string[]): JSX.Element => renderIcon(ChevronDownIcon, classNames),
  chevronRight: (...classNames: string[]): JSX.Element => renderIcon(ChevronRightIcon, classNames),
  chevronLeft: (...classNames: string[]): JSX.Element => renderIcon(ChevronLeftIcon, classNames),
  pencil: (...classNames: string[]): JSX.Element => renderIcon(Pencil, classNames),
  calendar: (...classNames: string[]): JSX.Element => renderIcon(Calendar, classNames),
  calendarWhite: (...classNames: string[]): JSX.Element => renderIcon(CalendarWhite, classNames),
  chart: (...classNames: string[]): JSX.Element => renderIcon(Chart, classNames),
  clear: (...classNames: string[]): JSX.Element => renderIcon(Clear, classNames),
  clearAlt: (...classNames: string[]): JSX.Element => renderIcon(ClearAlt, classNames),
  upload: (...classNames: string[]): JSX.Element => renderIcon(Upload, classNames),
  uploadAlt: (...classNames: string[]): JSX.Element => renderIcon(UploadAlt, classNames),
  user: (...classNames: string[]): JSX.Element => renderIcon(User, classNames),
  commercial: (...classNames: string[]): JSX.Element => renderIcon(Commercial, classNames),
  calculations: (...classNames: string[]): JSX.Element => renderIcon(Calculations, classNames),
  insurance: (...classNames: string[]): JSX.Element => renderIcon(Insurance, classNames),
  coApplicants: (...classNames: string[]): JSX.Element => renderIcon(CoApplicants, classNames),
  coApplicantsRed: (...classNames: string[]): JSX.Element =>
    renderIcon(CoApplicantsRed, classNames),
  customer: (...classNames: string[]): JSX.Element => renderIcon(Customer, classNames),
  customerRed: (...classNames: string[]): JSX.Element => renderIcon(CustomerRed, classNames),
  chevronRightWhite: (...classNames: string[]): JSX.Element =>
    renderIcon(ChevronRightWhite, classNames),
  chevronLeftWhite: (...classNames: string[]): JSX.Element =>
    renderIcon(ChevronLeftWhite, classNames),
  ellipse: (...classNames: string[]): JSX.Element => renderIcon(Ellipse, classNames),
  polygon: (...classNames: string[]): JSX.Element => renderIcon(Polygon, classNames),
  rectangle: (...classNames: string[]): JSX.Element => renderIcon(Rectangle, classNames),
  trash: (...classNames: string[]): JSX.Element => renderIcon(Trash, classNames),
  open: (...classNames: string[]): JSX.Element => renderIcon(Open, classNames),
  print: (...classNames: string[]): JSX.Element => renderIcon(Print, classNames),
  documents: (...classNames: string[]): JSX.Element => renderIcon(Documents, classNames),
  download: (...classNames: string[]): JSX.Element => renderIcon(Download, classNames),
  checked: (...classNames: string[]): JSX.Element => renderIcon(Checked, classNames),
  redInfo: (...classNames: string[]): JSX.Element => renderIcon(RedInfo, classNames),
};
